import ClientForm from '@/view/forms/client-form'
import { BadgeDollarSign, PlusCircle, User } from 'lucide-react'
import { useState } from 'react'
import { Tabs, TabsList, TabsTrigger } from '../../components/ui/tabs'
import { DisplayClient } from './panels/display-client'
import { ReceptionQuickSell } from './reception-quick-sell'

export default function ReceptionPage() {
  const [tab, setTab] = useState('members')

  return (
    <div className="w-full">
      <main className="flex flex-col gap-6">
        <div className="w-full overflow-y-scrol flex justify-between">
          <Tabs defaultValue="members" className="w-[320px]" onValueChange={setTab}>
            <TabsList>
              <TabsTrigger value="members" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                <User />
                Clientes
              </TabsTrigger>
              <TabsTrigger value="register-member" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                <PlusCircle className="text-sm" />
                Pré-Cadastro
              </TabsTrigger>
              <TabsTrigger value="quick-sale" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
                <BadgeDollarSign />
                Venda Rápida
              </TabsTrigger>
            </TabsList>
          </Tabs>

          <div className="flex gap-2">
            {/* <Button className="text-acelerait-black flex gap-2 text-sm" variant="outline">
              <ListFilter />
              Filtro
            </Button> */}
          </div>
        </div>
        <div className="flex flex-col gap-4 border-acelerafit-gray-white rounded-md border p-6">
          {tab == 'members' && (
            <>
              <header>
                <h3 className="text-acelerait-black text-2xl font-bold">Clientes</h3>
                <p className="text-sm text-acelerait-black">Gerencie e acompanhe o cadastro, status e informações dos clientes.</p>
              </header>
              <div className="">
                <DisplayClient />
              </div>
            </>
          )}

          {tab == 'register-member' && (
            <>
              <header>
                <h3 className="text-acelerait-black text-2xl font-bold">Adicionar cliente</h3>
                <p className="text-sm text-acelerait-black">Preencha as informações abaixo para registrar um novo cliente no sistema.</p>
              </header>
              <ClientForm />
            </>
          )}

          {tab == 'quick-sale' && (
            <>
              <header>
                <h3 className="text-acelerait-black text-2xl font-bold">Venda Rápida</h3>
                <p className="text-sm text-acelerait-black">Preencha as informações abaixo para realizar uma venda rápida.</p>
              </header>
              <ReceptionQuickSell />
            </>
          )}
        </div>
      </main>
    </div>
  )
}
